import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {BaseService} from '../base.service';
import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Paging} from '../../models/latipay/paging.model';
import {Sorts} from '../../models/admin/sorts.model';

@Injectable()
export class VirtualGoodService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('virtual-good', http);
    }

    ngOnInit(): void {
    }

    getAllVirtualGoodsByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        // const sortStr = sortOprions.getSortString();
        return this.http.get(`${this.url}?` + `${paging.getPagingStr()}${this.embeddedStr + searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllRedByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        const str = '&f_category_op==&f_category=9';
        return this.http.get(`${this.url}?` + `${paging.getPagingStr()}${this.embeddedStr + searchCondition + str}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllOtherByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        // const sortStr = sortOprions.getSortString();
        const str = '&f_category_op==&f_category=10';
        return this.http.get(`${this.url}?` + `${paging.getPagingStr()}${this.embeddedStr + searchCondition + str}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllByBusinessIdByPaging(searchCondition: string, businessId: number, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }

        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition}&sort=id,desc` + (businessId ? `&f_businessId=${businessId}&f_businessId_op==` : '')).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllByWalletIdsByPaging(walletIds: string[], searchCondition: string, paging: Paging) {
        const sortStr = '&sort=id,asc';
        let walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(id => {
                walletIdsStr += `&f_acceptedMerchants=${id}`;
            })
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(`${this.url}?${paging.getPagingStr()}${walletIdsStr}${sortStr}${searchCondition}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res))
        );
    }

    publishCouponById(id: string) {
        return this.http.post(`${this.url}/${id}/dispatch`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    deleteVg(id: number) {
        return this.http.post(`${this.url}/${id}/delete`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    addPrize(value: any) {
        return this.http.post(`${this.url}/add-prize`, value).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }
}
